import { withTranslation, WithTranslation } from 'react-i18next';
import React, { ChangeEvent } from 'react';
import { IFormModalRef } from '../../../modal/modal';
import { IProvinceModel } from '../../../../helpers/models/provinceModel';
import { IRoleModel } from '../../../../helpers/models/roleModel';
import { ReactComponent as NotificationLogo } from '../../../../styles/img/icons/error.svg';
import { termsAndConditionsEn, termsAndConditionsFr } from '../../registration';
import { IFormEligibilityModalRef } from '../../../modal/instances/eligibility/formEligibilityModal';

export interface IAuthorizationProps extends WithTranslation {
    provinces: IProvinceModel[];
    roles: IRoleModel[];
    eligibilityRef: React.RefObject<IFormModalRef & IFormEligibilityModalRef>;
}

const Authorization = (props: IAuthorizationProps) => {
    const { t, i18n, eligibilityRef } = props;

    const termAndConditions = (
        <a
            className="standalone-link"
            href={i18n.language === 'en' ? termsAndConditionsEn : termsAndConditionsFr}
            target="_blank"
            rel="noreferrer"
        >
            <span className="accessibility-hidden">
                {t('external_link_label', { ns: 'accessibility' })}
            </span>
            {t('form_authorization_term_and_condition_cta_title')}
        </a>
    );

    const handleOnBlur = (e: ChangeEvent<HTMLInputElement>) => {
        document
            .querySelector('label[for="' + e.target.id + '"]')!
            .classList.remove('field-focused');
    };
    const handleOnFocus = (e: ChangeEvent<HTMLInputElement>) => {
        document.querySelector('label[for="' + e.target.id + '"]')!.classList.add('field-focused');
    };

    const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.value) {
            document
                .getElementById(e.target.name + '_label')!
                .classList.remove('registration-error');
            document.getElementById(e.target.name + '-error')!.style.display = 'none';
        }
    };

    return (
        <>
            <div className="registration-authorization-container">
                <label
                    id="form_authorization_legal_terms_label"
                    htmlFor="form_authorization_legal_terms"
                    className="checkbox"
                >
                    <div>
                        {t('form_authorization_legal_terms_1')}
                        {termAndConditions}
                        {t('form_authorization_legal_terms_2')}
                        {termAndConditions}
                        {t('form_authorization_legal_terms_3')}
                    </div>
                    <input
                        className="checkbox-input field-value"
                        type="checkbox"
                        id="form_authorization_legal_terms"
                        name="form_authorization_legal_terms"
                        onBlur={handleOnBlur}
                        onFocus={handleOnFocus}
                        onChange={handleCheckboxChange}
                        data-set-weight={9}
                    />
                    <span className="checkmark"></span>
                </label>
                <div id="form_authorization_legal_terms-error" className="radio-button-error">
                    <NotificationLogo className="radio-button-error-icon" />
                    <span className="field-value radio-button-error-value registration-error">
                        Required
                    </span>
                </div>
                <label
                    id="form_authorization_eligible_label"
                    htmlFor="form_authorization_eligible"
                    className="checkbox"
                >
                    <div>
                        {t('form_authorization_eligible_1')}
                        <div id="eligible-link">
                            <a
                                tabIndex={0}
                                className="standalone-link"
                                role="button"
                                onClick={() => eligibilityRef.current?.setModalOpen(true)}
                            >
                                {t('form_authorization_eligible_cta_title')}
                            </a>
                        </div>
                        {t('form_authorization_eligible_2')}
                    </div>
                    <input
                        className="checkbox-input field-value"
                        type="checkbox"
                        id="form_authorization_eligible"
                        name="form_authorization_eligible"
                        onBlur={handleOnBlur}
                        onFocus={handleOnFocus}
                        onChange={handleCheckboxChange}
                        data-set-weight={10}
                    />
                    <span className="checkmark checkmark--disabled"></span>
                </label>
                <div id="form_authorization_eligible-error" className="radio-button-error">
                    <NotificationLogo className="radio-button-error-icon" />
                    <span className="field-value radio-button-error-value registration-error">
                        Required
                    </span>
                </div>
                <label
                    id="form_authorization_terms_label"
                    htmlFor="form_authorization_terms"
                    className="checkbox"
                >
                    <div>
                        {t('form_authorization_terms_1')}
                        {termAndConditions}
                        {t('form_authorization_terms_2')}
                        {termAndConditions}
                        {t('form_authorization_terms_3')}
                    </div>
                    <input
                        className="checkbox-input field-value"
                        type="checkbox"
                        id="form_authorization_terms"
                        name="form_authorization_terms"
                        onBlur={handleOnBlur}
                        onFocus={handleOnFocus}
                        onChange={handleCheckboxChange}
                        data-set-weight={11}
                    />
                    <span className="checkmark checkmark--disabled"></span>
                </label>
                <div id="form_authorization_terms-error" className="radio-button-error">
                    <NotificationLogo className="radio-button-error-icon" />
                    <span className="field-value radio-button-error-value registration-error">
                        Required
                    </span>
                </div>
            </div>
        </>
    );
};

export default withTranslation()(Authorization);
